import React, { useCallback } from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';
import { useNavigate } from 'react-router-dom';

import ActionButton from 'components/action-button';
import { IImageFragment } from 'generated/sanity-graphql';
import useMediaQuery from 'hooks/use-media-query';
import useRoutes from 'hooks/use-routes';

import {
  BackgroundPicture,
  Container,
  Description,
  Name,
  OfferInfoContainer,
  OfferPicture,
} from './details-panel-components';
import { ILinkAction } from './use-feature-offers';

export interface IDetailsPanelErrorProps {
  backgroundImage: IImageFragment | null;
  image: IImageFragment | null;
  title: string | null;
  body: string | null;
  action: ILinkAction | null;
  showAction: boolean;
  titleTestId?: string;
  bodyTestId?: string;
  actionButtonTestId?: string;
}

export const DetailsPanelError: React.FC<IDetailsPanelErrorProps> = ({
  backgroundImage,
  image,
  title,
  body,
  action,
  showAction,
  titleTestId,
  bodyTestId,
  actionButtonTestId,
}) => {
  const { getLocalizedRouteForPath } = useRoutes();

  const { route, actionText } = action ?? {};
  const navigate = useNavigate();
  const isDesktop = useMediaQuery('desktop');
  const onClick = useCallback(() => {
    if (route) {
      navigate(getLocalizedRouteForPath(route));
    }
  }, [route, navigate, getLocalizedRouteForPath]);

  return (
    <Container>
      {backgroundImage && (
        <BackgroundPicture alt="" image={backgroundImage} objectFitContain={false} />
      )}
      {image && <OfferPicture image={image} alt={title ?? ''} />}
      <OfferInfoContainer>
        <Name data-testid={titleTestId}>{title}</Name>
        <Description data-testid={bodyTestId}>{body}</Description>

        {showAction && actionText && (
          <Box margin={isDesktop ? '1.2rem 0 0' : '1rem 0 0'}>
            <ActionButton data-testid={actionButtonTestId} onClick={onClick}>
              {actionText}
            </ActionButton>
          </Box>
        )}
      </OfferInfoContainer>
    </Container>
  );
};
